import api from "@/lib/axiosConfig";
import { z, ZodType } from "zod";
import { baseRoute } from "./multipleprint";

export const multipleprintSchema = z.object({
  id: z.string().optional(),

  estampesMultiplesDescriptionNumeroEnregistrement: z
    .string()
    .nonempty("form.error.emptyField"),

  estampesMultiplesDescriptionTitre: z.string(),
});

export const appendNoDuplicateRecordNumberRefine = <
  T extends {
    id?: string;
    estampesMultiplesDescriptionNumeroEnregistrement: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordNumbers(
        val.estampesMultiplesDescriptionNumeroEnregistrement,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.multipleprint.duplicateRegistrationNumbers",
      path: ["estampesMultiplesDescriptionNumeroEnregistrement"],
    },
  );

export async function validateNoDuplicateRecordNumbers(
  registrationNumber: string,
  id?: string,
) {
  await api.get<void>(`${baseRoute}/record-number/validate/no-duplicates`, {
    params: {
      value: registrationNumber,
      id,
    },
  });
}
